import { FaRegCheckCircle } from "react-icons/fa";

interface FormSuccessProps {
    message: string;
}

export const FormSuccess = ({ message }: FormSuccessProps) => {
    if (!message) return null;

    return (
        <div className="bg-emerald-100 p-3 rounded flex items-center gap-x-2 text-sm mt-0 text-emerald-500">
            <FaRegCheckCircle className="h-4 w-4" />
            <p>{message}</p>
        </div>
    );
}